const Images = {
  STUDENT_MASK: require("../assets/img/student-mask.png").default,
  STUDENT_REMOTE: require("../assets/img/student-remote.png").default,
  ICON_LOCK: require("../assets/img/icon-lock.png").default,
  LIVE_LECTURE_HEADER: require("../assets/img/live-lecture-header.png").default,
  WHO_AM_I: require("../assets/img/who-am-i.png").default,
  JOIN_LECTURE: require("../assets/img/join-lecture.png").default,
  STATS_PREVIEW: require("../assets/img/stats-preview.png").default,
  PRESENTATION_VIEW: require("../assets/img/presentation-view.png").default,
  TEACHER_REMOTE: require("../assets/img/teacher-remote.png").default,
  NO_PRESENTATION: require("../assets/img/no-presentation.png").default,
  VIDEO_INTERACTION: require("../assets/img/video-interaction.png").default,

  NEW_LIVE: require("../assets/img/new-live.png").default,
  NEW_LOCK: require("../assets/img/new-lock.png").default,
  NEW_HOW_AM_I: require("../assets/img/new-how-am.png").default,
  NEW_JOIN_LECTURE: require("../assets/img/new-join-lecture.png").default,
  NEW_REMOTE_WEB: require("../assets/img/new-remote-web.png").default,
  NEW_REMOTE_MOB: require("../assets/img/new-remote-mob.png").default,
  NEW_STATS_PREVIEW: require("../assets/img/new-stats-preview.png").default,
  NEW_VIEW_PDF: require("../assets/img/new-view-pdf.png").default,
  NEW_VIEW_REMOTE: require("../assets/img/new-view-remote.png").default,
  NEW_QA: require("../assets/img/new-qa.png").default,
  NEW_REGISTRATION: require("../assets/img/new-registration.png").default,
};

export default Images;
